export default {
    computedTrips () {
        return this.trips.map(trip => {
            let getMonth = (date) => {
                return date.getMonth() + 1
            }

            let date1 = new Date(trip.startTime)
            let date2 = new Date(trip.stopTime)
            let diffTime = Math.abs(date2 - date1)
            let diffHours = Math.ceil(diffTime / (1000 * 60 * 60))

            let day = date1.getDate()
            let month = getMonth(date1)
            const dateNow = new Date()

            day = day < 10 ? `0${day}` : day
            month = month < 10 ? `0${month}` : month

            let durationDateText = String(`${day}/${month}`)

            if (diffHours >= 24) {
                day = date2.getDate()
                month = getMonth(date2)

                day = day < 10 ? `0${day}` : day
                month = month < 10 ? `0${month}` : month

                durationDateText = durationDateText.concat(` até ${day}/${month}`)
            }

            trip.tripBlocking = date1 < dateNow

            return {
                ...trip,
                durationDateText: durationDateText,
            }
        })
    }
}
